import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { PShotHero } from '../components/p-shot/PShotHero';
export function PShotPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2605">
      <Navigation data-id="element-2606" />
      <main data-id="element-2607">
        <PShotHero data-id="element-2608" />
      </main>
      <Footer data-id="element-2609" />
    </div>;
}